import './style.scss';
import $ from 'jquery';
import { gsap } from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger.js";

gsap.registerPlugin(ScrollTrigger);

function revealFunction() {
	if($(".wp-block-keztablocks-featured.anim-reveal").length) {

		ScrollTrigger.batch(".wp-block-keztablocks-featured-box", {
		  onEnter: batch => {
		    batch.forEach((section, i) => {
		      gsap.fromTo(section, {autoAlpha:0,y:40}, {
		      	autoAlpha: 1,
		      	y: 0,
		        duration: 0.6,
		        stagger: 0.1,
		        delay: i * 0.3,
		      });
		    });
		  },
  		  once: true,
		  start: "+=100 bottom"
		});
	}
}

function socialFunction() {
	if($(".wp-block-keztablocks-featured-box").length > 0) {
		$(".wp-block-keztablocks-featured-box").each(function() {
			var self = $(this),
				wrapper = self.find('.wp-block-keztablocks-featured-box__icon'),
				icon = self.find('.wp-block-keztablocks-featured-box__icon svg'),
			    dataHoverBgColor = wrapper.attr("data-hbgcolor"),
			    dataHoverBorColor = wrapper.attr("data-hborcolor"),
			    dataHoverColor = wrapper.attr("data-hcolor"),
			    tl = gsap.timeline({paused:true});
			tl.to(wrapper, {duration:0.3, backgroundColor: dataHoverBgColor, borderColor: dataHoverBorColor,ease:"none"})
			.to(icon, {duration: 0.3, fill:dataHoverColor},'<');

			self.on("mouseenter", () => {
				tl.play();
			}).on("mouseleave", () => {
				tl.reverse();
			})
		})
	}
}

$(window).on('load', () => {
  if($('.c-loader').length) {
    setTimeout(() => { 
          revealFunction();
      }, 3200);
  } else {
    setTimeout(() => { 
          revealFunction();
      }, 400);
  }
  socialFunction()
})